import React, { forwardRef } from 'react';

const InnerModal = forwardRef(function InnerModal(props, ref) {
  return (
    <div
      className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 drop-shadow-2xl border border-black rounded-lg p-4 bg-base-100 w-fit min-w-80 z-50"
      ref={ref} // maybe ref will not be necessary
    >
      {props.children}
    </div>
  );
});

export default InnerModal;
